import { useCallback, useContext } from 'react';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';
import ModalContext from '~/context/srp/ModalContext';
import { useOpenAccountModal } from '~/hooks/common/useAccountModal';

export default function useLogInAndManageSavedSearches() {
  const { setManageSavedSearchesOpen } = useContext(ModalContext);
  const { triggerFetchUserProfile } = useContext(UserContext);
  const openAccountModal = useOpenAccountModal();
  const isLoggedIn = useIsLoggedIn();

  const onSuccess = useCallback(() => {
    triggerFetchUserProfile();
    setManageSavedSearchesOpen(true);
  }, [setManageSavedSearchesOpen, triggerFetchUserProfile]);

  return useCallback(() => {
    if (isLoggedIn) {
      setManageSavedSearchesOpen(true);

      return;
    }

    openAccountModal({
      callerIdentifier: 'SearchAlert',
      displayTitle: 'MANAGE SAVED SEARCHES',
      onSuccess
    });
  }, [isLoggedIn, onSuccess, openAccountModal, setManageSavedSearchesOpen]);
}
